<template>
  <div class="mx-1">
    <v-dialog v-model="isOpen">
      <template v-slot:activator="{ on, attrs }">
        <v-icon medium color="info" v-bind="attrs" v-on="on">print</v-icon>
      </template>
      <v-card>
        <v-card-title class="text-h5 lighten-2">Label #{{ this.orderNumber }}</v-card-title>
        <v-card-text>
          <v-container v-if="this.patient !== null">
            <div>
              <p class="mb-1">
                <strong>ชื่อ </strong>{{ this.patient.firstname }}
                {{ this.patient.lastname }}
              </p>
              <p class="mb-1"><strong>โทร </strong>{{ telLabel }}</p>
              <p class="mb-1">
                <strong>ที่อยู่ </strong>{{ this.patient.address }}
                {{ this.patient.district.name.th }}
                {{ this.patient.city.name.th }}
                {{ this.patient.province.name.th }}
                {{ this.patient.district.zip_code }}
              </p>
              <p class="mb-1">
                <strong>แพทย์ </strong>{{ this.provider.prefix.th }}
                {{ this.provider.firstname.th }}
                {{ this.provider.lastname.th }}
              </p>
            </div>
            <medicine-detail v-for="medicine in medicines" :key="medicine.id" :medicine="medicine" ref="meds" />
          </v-container>
          <v-container v-else>
            <v-icon large color="info" class="mx-auto">hourglass_empty</v-icon>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn variant="primary" class="mx-auto mb-4" color="primary" @click="generatePDF">
            <v-icon>download</v-icon> Download PDF</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import AppointmentService from '../../../../services/appointment';
import MedicineDetail from './MedicineDetail.vue';
export default {
  name: 'LabelDialog',
  components: {
    MedicineDetail,
  },
  data() {
    return {
      isOpen: false,
      patient: null,
      provider: null,
    };
  },
  props: {
    medicines: {
      type: Array,
      required: true,
    },
    appointmentId: {
      type: String,
      required: true,
    },
    orderNumber: {
      type: String,
      required: true,
    },
  },
  computed: {
    telLabel() {
      const tel = /(\+\d{2})(\d{2})(\d{3})(\d{4})/.exec(this.patient.user.tel);
      if (!tel || tel.length < 5) {
        return '';
      }
      return `0${tel[2]}-${tel[3]}-${tel[4]}`;
    },
  },
  methods: {
    async getAppointmentById() {
      if (this.isOpen && this.patient === null) {
        const appointment = await AppointmentService.getAppointmentById(this.appointmentId);
        this.patient = appointment.patient_profile;
        this.provider = appointment.provider_profile;
      }
    },
    async generatePDF() {
      const pdfData = {
        date: new Date()
          .toLocaleDateString('th-TH', {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
          })
          .toString(),
        patient: {
          name: `${this.patient.firstname} ${this.patient.lastname}`,
          tel: this.telLabel,
          address: `${this.patient.address} ${this.patient.district.name.th} ${this.patient.city.name.th} ${this.patient.province.name.th} ${this.patient.district.zip_code}`,
        },
        provider: `${this.provider.prefix.th} ${this.provider.firstname.th} ${this.provider.lastname.th}`,
        medicines: this.$refs.meds.map((m) => {
          return {
            name: `${m.medicine.genericName} / ${m.medicine.tradeName}`,
            amount: m.amountLabel,
            dosage: m.dosageLabel,
            advice: m.adviceLabel,
            property: m.medicine.phamarcistDetail,
            dosageAmount: m.medicine.amount,
          };
        }),
      };
      var printWindow = window.open('', '', 'height=500,width=800');
      var html = `
      <!DOCTYPE html>
      <html lang="en">

      <head>
        <meta charset="UTF-8">
        <meta name="viewport" content="width=device-width, initial-scale=1.0">
        <title>_TITLE_</title>
        <link rel="preconnect" href="https://fonts.googleapis.com">
        <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin="">
        <link href="https://fonts.googleapis.com/css2?family=Prompt:wght@300;400;500&amp;display=swap" rel="stylesheet">
        <style>
          body {
            font-family: "Prompt", sans-serif;
            font-weight: 300;
            margin: 0;
            padding: 0;
          }

          .address {
            margin-top: 2pt;
            margin-right: 2pt;
            margin-left: 120px;
          }

          .header {
            display: flex;
            padding: 1mm 0 0 0;
            margin: 2mm 2mm -2.5mm 2mm;
          }

          .header .address span {
            display: block;
            font-size: 8pt;
            line-height: 1.2;
            color: #3D74BA;
          }

          .provider {
            padding: 0.5mm 0;
            position: absolute;
            bottom: 2mm;
            width: 86mm;
            margin: 0 2mm;
            font-size: 9.5pt;
            font-weight: bold;
            display: flex;
            justify-content: space-between;
          }

          table.med-detail {
            font-size: 8.5pt;
            margin: 5mm 2mm 1mm 2mm;
          }

          table.med-detail tr {
            line-height: 13px;
          }

          table.med-detail td.big-text {
            font-size: 9.5pt;
          }

          table.med-detail td {
            vertical-align: top;
          }

          table.med-detail td:nth-child(1) {
            font-weight: bold;
            min-width: 18mm;
          }

          table.med-detail .advice-text {
            width: 66mm;
            white-space: normal;
            overflow-wrap: break-word;
            word-break: break-word;
          }

          /* Auto-shrink เมื่อข้อความยาว เพื่อให้พอดีกับฉลาก 90x60mm */
          table.med-detail.compact {
            font-size: 7.5pt;
          }

          table.med-detail.compact tr {
            line-height: 11px;
          }

          table.med-detail.compact td.big-text {
            font-size: 8.5pt;
          }

          table.med-detail.compact-sm {
            font-size: 6.5pt;
          }

          table.med-detail.compact-sm tr {
            line-height: 10px;
          }

          table.med-detail.compact-sm td.big-text {
            font-size: 7.5pt;
          }

          @page {
            size: 90mm 60mm;
            margin: 0mm;
          }

          .page {
            width: 90mm;
            height: 60mm;
            margin: 0;
            overflow: hidden;
            position: relative;
            box-sizing: border-box;
          }

          .page.medicine {
            padding: 0;
          }

          .border {
            position: absolute;
            bottom: 0;
            height: 2mm;
            width: 100%;
            background: #00c4b3;
          }

          .body {
            padding: 2mm 3mm;
            margin-top: 2mm;
          }

          .ooca-name {
            font-size: 10.5pt;
            font-weight: bold;
          }

          .ooca-address {
            font-size: 8.5pt;
          }

          .patient-name {
            font-size: 10.5pt;
            font-weight: bold;
          }

          .patient-address {
            font-size: 8.5pt;
          }

          .dash-line {
            border-top: 2px dashed #000;
            margin: 2mm 0mm 1mm 0mm;
            border-color: #1F77DF;
          }

          .patient-name .label, .ooca-name .label {
            margin-right: 1mm;
          }
        </style>
      </head>
      <body>
        <div class="page">
          <div style="display: flex; flex-direction: column;">
            <div class="header" style="display: flex; justify-content: start; align-items: center;">
              <div class="address">
                <span>
                  <strong style="font-weight: bold;">_CLINIC_NAME_</strong>
                </span>
                <span>
                  <strong>โทร 02-114-7721, Line ID: _COMPANY_LINE_</strong>
                </span>
              </div>
            </div>
            <div class="body">
              <div class="ooca-name" style="display: flex;">
                <div class="label">
                  ผู้ส่ง :
                </div>
                <div>
                  _COMPANY_NAME_
                </div>
              </div>
              <div class="ooca-address">
                <span>
                  _COMPANY_ADDRESS_
                </span>
              </div>
              <div class="dash-line"></div>
              <div class="patient-name" style="display: flex;">
                <div class="label">
                  ผู้รับ : 
                </div>
                <div>
                  _PATIENT_NAME_
                </div>
              </div>
              <div class="patient-address">
                <div style="line-height: 1.3em;">
                  _PATIENT_ADDRESS_ _PATIENT_TEL_
                </div>
              </div>
            </div>
          </div>
        </div>
        _MEDICINES_
      </body>
      </html>
      `;

      var medicinesHtmlTemplate = `
      <div class="page medicine">
        <div class="header">
          <div class="address">
            <span>
              <strong style="font-weight: bold;">_CLINIC_NAME_</strong>
            </span>
            <span>
              <strong>_CLINIC_CONTACT_</strong>
            </span>
          </div>
        </div>
        <table class="med-detail _MED_DETAIL_CLASS_">
          <tbody>
            <tr>
              <td colspan="2" class="big-text">_PATIENT_NAME_</td>
            </tr>
            <tr>
              <td colspan="2" class="big-text">_MED_NAME_ (_MED_DOSAGE_AMOUNT_)<span style="color: #7A8FA2; font-weight: initial;"> | </span> _MED_COUNT_</td>
            </tr>
            <tr>
              <td>ข้อบ่งใช้</td>
              <td><div>_MED_PROPERTY_</div></td>
            </tr>
            <tr>
              <td>วิธีรับประทาน</td>
              <td>_MED_HOW_TO_TAKE_</td>
            </tr>
            _MED_ADVICE_PLACE_HOLDER_
          </tbody>
        </table>
        <span class="smt provider">
          <span>_PROVIDER_NAME_</span>
          <span>_PRESCRIBE_DATE_</span>
        </span>
        <div class="border"></div>
      </div>
      `;

      var medAdviceTemplate = `
      <tr>
        <td>คำแนะนำ</td>
        <td><div class="advice-text">_MED_ADVICE_</div></td>
      </tr>
      `;

      var medicinesHtml = '';

      // Company Address
      html = html
        .replace('_TITLE_', this.orderNumber)
        .replace('_CLINIC_NAME_', 'อูก้า สหคลินิก')
        .replace('_COMPANY_NAME_', 'บริษัท เทเลเมดิก้า จำกัด')
        .replace(
          '_COMPANY_ADDRESS_',
          '6A-5/1 ชั้น 6 อาคารเกษร เซ็นเตอร์ เลขที่ 999 ถนนเพลินจิต แขวงลุมพินี เขตปทุมวัน กรุงเทพมหานคร 10330'
        )
        .replace('_COMPANY_LINE_', 'Line: @ooca');

      // Patient Address
      html = html
        .replace('_PATIENT_NAME_', pdfData.patient.name)
        .replace('_PATIENT_TEL_', pdfData.patient.tel)
        .replace('_PATIENT_ADDRESS_', pdfData.patient.address);

      for (let i = 0; i < pdfData.medicines.length; i++) {
        const medicine = pdfData.medicines[i];

        // ลดขนาดฟอนต์อัตโนมัติตามความยาวรวมของข้อความที่ wrap ได้
        // (ข้อบ่งใช้ + วิธีรับประทาน + คำแนะนำ) เพื่อให้พอดีกับฉลาก 90x60mm
        const contentLength =
          (medicine.property || '').length + (medicine.dosage || '').length + (medicine.advice || '').length;
        let detailClass = '';
        // if (contentLength > 220) {
        //   detailClass = 'compact';
        // } else if (contentLength > 130) {
        //   detailClass = 'compact';
        // }

        var medicineHtml = medicinesHtmlTemplate
          .replace('_MED_DETAIL_CLASS_', detailClass)
          .replace('_CLINIC_NAME_', 'อูก้า สหคลินิก')
          .replace('_CLINIC_CONTACT_', 'โทร 02-114-7721, Line ID: @ooca')
          .replace('_PATIENT_NAME_', pdfData.patient.name.toUpperCase())
          .replace('_PRESCRIBE_DATE_', pdfData.date)
          .replace('_MED_NAME_', medicine.name)
          .replace('_MED_COUNT_', medicine.amount)
          .replace('_MED_HOW_TO_TAKE_', medicine.dosage)
          .replace('_MED_PROPERTY_', medicine.property)
          .replace('_MED_DOSAGE_AMOUNT_', medicine.dosageAmount)
          .replace('_PROVIDER_NAME_', pdfData.provider);

        var medAdvice = medAdviceTemplate;
        if (medicine.advice !== undefined && medicine.advice.trim().length > 0) {
          medAdvice = medAdvice.replace('_MED_ADVICE_', medicine.advice);
          medicineHtml = medicineHtml.replace('_MED_ADVICE_PLACE_HOLDER_', medAdvice);
        } else {
          medicineHtml = medicineHtml.replace('_MED_ADVICE_PLACE_HOLDER_', '');
        }

        medicinesHtml += medicineHtml;
      }

      html = html.replace('_MEDICINES_', medicinesHtml);

      printWindow.document.write(html);
      printWindow.document.close();
      setTimeout(() => {
        printWindow.print();
      }, 1000);
    },
  },
  watch: {
    isOpen() {
      if (this.isOpen && this.patient === null) this.getAppointmentById();
    },
  },
};
</script>
